import React from 'react';
import { hot } from 'react-hot-loader';
import { origin } from '../../config';
import { prefix, translate } from '../../utils/locale';
import { purifier } from '../../utils/dom';

const StructuredData = ({ meta, list, setup }) => {
	const jsonData = {
		'@context': 'http://schema.org/',
		'@type': 'ItemList',
		itemListOrder: 'Unordered',
		description: translate(setup, meta.metaDescription || ''),
		name: translate(setup, meta.metaTitle || ''),
		url: meta.linkCanonical,
		numberOfItems: list.length,
		itemListElement: list.map((item, i) => ({
			'@type': 'ListItem',
			image: item?.image?.[0],
			url: `${origin}${prefix(setup, item?.canonicalUri)}`,
			name: `${item.name}${item.variantName ? ` ${item.variantName}` : ''}`,
			position: i + 1,
		})),
	};

	return (
		<script type="application/ld+json" dangerouslySetInnerHTML={{ __html: purifier(JSON.stringify(jsonData), { ALLOWED_TAGS: [] }) }} />
	);
};

export default hot(module)(StructuredData);
